<template>
  <div class='coursework-viewer__slide'>
    <div v-if="!loading" class='js-preview-container'>
      <iframe v-if="showPreview" class='iframe-link-preview' :src="media.url"></iframe>
      
      <div v-if="!showPreview" class='coursework-viewer__no-preview'>
        <div class='coursework-viewer__no-preview_icon'>
          <img v-if="media.data.thumb" :src="media.data.thumb">
          <span v-else="true" class='kf-stack kf-stack--circle'>
            <i class='kf kf-circle-outline'></i>
            <i class='kf kf-external-link'></i>
          </span>
        </div>
        <div class='coursework-viewer__no-preview_title'>This link cannot be previewed</div>
        <div class='coursework-viewer__no-preview_description'>Click on the link below to open it in a new window.</div>
        <div class='coursework-viewer__no-preview_link'>
          <a class='inline-bold-link inline-bold-link--light' target="_blank" :href="media.url">Open Link</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      media: Object
    },
    data() {
      return {
        loading: true,
        showPreview: false
      }
    },
    methods: {
      fetchHeaders: _.memoize(function (src) {
        let url = Kadenze.Routes.temp_file_headers_path({url: src});

        return new Kadenze.AjaxRequest({
          type: 'GET',
          url: url,
          dataAsJSON: false,
          timeout: 60000,
          loadingIndicator: {positionTop: 'absolute'}
        });
      }),
      init() {
        if (this.media.url.indexOf('https://') === 0) {
          let request = this.fetchHeaders(this.media.url);

          request.done((data) => {
            let headers = data.headers;
            if(headers['x-frame-options'] && (headers['x-frame-options'].toUpperCase() === 'DENY' || headers['x-frame-options'].toUpperCase() === 'SAMEORIGIN')) {
              this.showPreview = false;
            } else {
              this.showPreview = true;
            }
          });

          request.error((data) => {
            this.showPreview = false;
          });

          request.always(() => {
            this.loading = false;
            this.$emit('ready', this.media.id)
          });
        } else {
          this.showPreview = false;
          this.loading = false;
          this.$emit('ready', this.media.id)
        }
      }
    },
    created() {
      this.$parent.slides.push(this);
    },
    mounted() {
      this.init();
    }
  }
</script>